export function initPaddle(store, loadScript) {
  loadScript('https://cdn.paddle.com/paddle/paddle.js').then(() => {
    store.commit('setIsPaddleReady', true);
  });
}